import { createBrowserRouter } from "react-router-dom";
import AnimatedScene from "../AnimatedScene";
import Glitch from "../glitch";
import Main from "../main";
import Projects from "../projects";
import OneProject from "../oneProject";
import About from "../aboute";
import Aboute from "../aboute";
import NotFound from "../notFound";
import Contact from "../contact";
import Home from "../home";


const router = createBrowserRouter([

      { path: "/animation", element: <AnimatedScene /> },
      // { path: "/1", element: <Glitch /> },
      // {
      //       path: '/',
      //       element: <AnimatedScene />, // First component
      //     },
          {
            path: '/glitch',
            element: <Glitch />, // Second component
          },
          {
          path: "/",
          element: <Main />, // Main layout component
          children: [
            {
              index: true, // Marks this route as the default for "/"
              element: <Home />, // Home page component
            },
            { path: "projects", element: <Projects /> },
            { path: "about", element: <Aboute /> },
            { path: "contact", element: <Contact /> },
            { path: "*", element: <NotFound /> }, // Catch-all route for 404s

        ],
      },
       // 404 Route
  // { path: "*", element: <NotFound /> }, // Wildcard route for unmatched paths
        ]);

export default router;


    